/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { CurateSearchActionsNames } from './fitting-tree-view-action-names';
import { ResultInformation } from '../../models/result-information';
import { FittingTreeView } from '../../models/fitting-tree-view-vm';

export const GetResultInformationFromTreeViewFolder = createAction(
  CurateSearchActionsNames.getResultInformationFromTreeViewFolderItems(),
  props<{ treeViewItems: FittingTreeView[] }>()
);

export const GetResultInformationFromTreeViewFolderSuccess = createAction(
  CurateSearchActionsNames.getResultInformationFromTreeViewFolderItemsSuccess(),
  props<{ resultInformation: ResultInformation[] }>()
);

export const GetTreeViewRootDirectory = createAction(CurateSearchActionsNames.getTreeViewRootDirectory());

export const GetTreeViewRootDirectorySucces = createAction(
  CurateSearchActionsNames.getTreeViewRootDirectorySuccess(),
  props<{ response: any }>()
);
